import CommonNavbar from "../../Common/CommonLayout/CommonNavbar";
import CommonFooter from "../../Common/CommonLayout/CommonFooter";
import Form from "react-bootstrap/Form";
import {
  Button,
  Card,
  CardBody,
  FormGroup,
  Input,
  InputGroupText,
  InputGroup,
  Row,
  Col,
  CardHeader,
} from "react-bootstrap";
import React, { useEffect, useState } from "react";
import "../../../App.css";
import { API_URL } from "../../../Constant.js";
import fetchWithAuth from "../../../fetchWithAuth.js";
import Select from "react-select";
const CounsellorRegistration = () => {
  const [firstName, setFirstName] = useState(localStorage.getItem("firstName"));
  const [lastName, setLastName] = useState(localStorage.getItem("lastName"));
  const [mobileNo, setMobileNo] = useState(localStorage.getItem("mobileno"));
  const [emailId, setEmailId] = useState(localStorage.getItem("emailId"));
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [selectedGender, setSelectedGender] = useState(null);
  const [selectedMaritalStatus, setSelectedMaritalStatus] = useState(null);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [streetAddress, setStreetAddress] = useState(null);
  const [pincode, setPincode] = useState(null);
  const [selectedEthnicity, setSelectedEthnicity] = useState(null);
  const [selectedReligion, setSelectedReligion] = useState(null);
  const [languagesKnown, setLanguagesKnown] = useState("");
  const [expertise, setExpertise] = useState("");
  const [masterDegree, setMasterDegree] = useState(null);
  const [mDUniversity, setMDUniversity] = useState(null);
  const [mDPassingYear, setMDPassingYear] = useState(null);
  const [graduationDegree, setGraduationDegree] = useState(null);
  const [gDUniversity, setGDUniversity] = useState(null);
  const [gDPassingYear, setGDPassingYear] = useState(null);
  const [otherQualification, setOtherQualification] = useState(null);
  const [yearsOfExperience, setYearsOfExperience] = useState(null);
  const [bio, setBio] = useState(null);
  const [individualCounselling, setIndividualCounselling] = useState(false);
  const [coupleCounselling, setCoupleCounselling] = useState(false);
  const [familyCounselling, setFamilyCounselling] = useState(false);
  const [maritalStatuses, setMaritalStatuses] = useState([]);
  const [ethnicities, setEthnicities] = useState([]);
  const [religions, setReligions] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [selectedLanguages, setSelectedLanguages] = useState([]);
  const [expertises, setExpertises] = useState([]);
  const [selectedExpertise, setSelectedExpertise] = useState([]);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [selectedCountryCode, setSelectedCountryCode] = useState(""); // Default empty
  const fullMobileNo = selectedCountryCode + mobileNo; // Concatenating country code with mobile number
  const jwtToken = localStorage.getItem("token");
  const loginId = localStorage.getItem("loginId");
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedResume, setSelectedResume] = useState(null);

  const [dateOfBirthError, setDateOfBirthError] = useState("");
  const [genderError, setGenderError] = useState("");
  const [maritalStatusError, setMaritalStatusError] = useState("");
  const [countryError, setCountryError] = useState("");
  const [stateError, setStateError] = useState("");
  const [streetAddressError, setStreetAddressError] = useState("");
  const [pincodeError, setPincodeError] = useState("");
  const [languagesError, setLanguagesError] = useState("");
  const [expertiseError, setExpertiseError] = useState("");
  const [masterDegreeError, setMasterDegreeError] = useState("");
  const [mdUniversityError, setMdUniversityError] = useState("");
  const [mdPassingYearError, setMdPassingYearError] = useState("");
  const [resumeError, setResumeError] = useState("");
  const [counsellingError, setCounsellingError] = useState("");
  const [yearsOfExperienceError, setYearsOfExperienceError] = useState("");

  const handleLanguagesKnownChange = (selected) => {
    setLanguagesKnown(selected);
    console.log("Selected Languages are : " + JSON.stringify(languagesKnown));
  };
  const validateForm = () => {
    let isValid = true;

    if (!dateOfBirth || dateOfBirth.trim() === "") {
      setDateOfBirthError("* Please enter date of birth");
      isValid = false;
    } else {
      setDateOfBirthError("");
    }

    if (!selectedGender) {
      setGenderError("* Please select gender");
      isValid = false;
    } else {
      setGenderError("");
    }

    if (!selectedMaritalStatus) {
      setMaritalStatusError("* Please select marital status");
      isValid = false;
    } else {
      setMaritalStatusError("");
    }

    if (!selectedCountry) {
      setCountryError("* Please select country");
      isValid = false;
    } else {
      setCountryError("");
    }

    if (!selectedState) {
      setStateError("* Please select state");
      isValid = false;
    } else {
      setStateError("");
    }

    if (!streetAddress || streetAddress.trim() === "") {
      setStreetAddressError("* Please enter street address");
      isValid = false;
    } else {
      setStreetAddressError("");
    }

    if (!pincode || pincode.trim() === "") {
      setPincodeError("* Please enter pincode");
      isValid = false;
    } else {
      setPincodeError("");
    }

    if (!selectedLanguages || selectedLanguages.length === 0) {
      setLanguagesError("* Please select at least one language");
      isValid = false;
    } else {
      setLanguagesError("");
    }

    if (!selectedExpertise || selectedExpertise.length === 0) {
      setExpertiseError("* Please select at least one area of expertise");
      isValid = false;
    } else {
      setExpertiseError("");
    }

    if (!masterDegree || masterDegree.trim() === "") {
      setMasterDegreeError("* Please enter master's degree");
      isValid = false;
    } else {
      setMasterDegreeError("");
    }

    if (!mDUniversity || mDUniversity.trim() === "") {
      setMdUniversityError("* Please enter university name");
      isValid = false;
    } else {
      setMdUniversityError("");
    }

    if (!mDPassingYear || mDPassingYear.trim() === "") {
      setMdPassingYearError("* Please enter passing year");
      isValid = false;
    } else {
      setMdPassingYearError("");
    }

    if (!selectedResume) {
      setResumeError("* Please upload resume");
      isValid = false;
    } else {
      setResumeError("");
    }

    if (!individualCounselling && !coupleCounselling && !familyCounselling) {
      setCounsellingError("* Please select at least one type of counselling");
      isValid = false;
    } else {
      setCounsellingError("");
    }

    if (!yearsOfExperience) {
      setYearsOfExperienceError("* Please enter years of experience");
      isValid = false;
    } else {
      setYearsOfExperienceError("");
    }

    return isValid;
  };
  const handleSubmit = async (event) => {
    event.preventDefault(); // prevent page reload
    const isValid = validateForm();
    if (!isValid) return; // stop if form is invalid
    // setIsLoading(true);

    const formData = new FormData();
    formData.append("LoginId", loginId);
    formData.append("dateOfBirth", dateOfBirth);
    formData.append("gender", selectedGender);
    formData.append("maritalStatusId", selectedMaritalStatus);
    formData.append("countryId", selectedCountry);
    formData.append("stateId", selectedState);
    formData.append("streetAdderess", streetAddress);
    formData.append("pincode", pincode);
    formData.append("ethinicityId", selectedEthnicity);
    formData.append("religionId", selectedReligion);
    formData.append("languagesKnown", languagesKnown);
    formData.append("expertise", expertise);
    formData.append("masterDegree", masterDegree);
    formData.append("mDUniversity", mDUniversity);
    formData.append("mDPassingYear", mDPassingYear);
    formData.append("graduationDegree", graduationDegree);
    formData.append("gDUniversity", gDUniversity);
    formData.append("gDPassingYear", gDPassingYear);
    formData.append("otherQualification", otherQualification);
    formData.append("resumeFileURL", "");
    formData.append("yearsOfExperience", yearsOfExperience);
    formData.append("bio", bio);
    formData.append("individualCounselling", individualCounselling);
    formData.append("coupleCounselling", coupleCounselling);
    formData.append("familyCounselling", familyCounselling);
    // add image & resume only if selected
    if (selectedImage) {
      formData.append("image", selectedImage);
    }
    if (selectedResume) {
      formData.append("resume", selectedResume);
    }
    try {
      const response = await fetch(
        `${API_URL}api/Counsellor/RegisterCounsellor`,
        {
          method: "POST",
          body: formData,
        }
      );
      if (response.ok) {
        const result = await response.json();
        // redirect to dashboard after successful submission
        window.location.href = "/counsellor/dashboard";
      } else {
        const errorText = await response.text();
        console.error("Error during save:", errorText);
        alert("Something went wrong! Please try again.");
      }
    } catch (error) {
      console.error("Error during save:", error);
      alert("Network error! Please try again later.");
    }
  };
  const fetchCountries = async () => {
    try {
      const response = await fetch(API_URL + "Masters/GetCountryList");
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      console.log("Fetched Countries:", data);

      if (data && Array.isArray(data.data)) {
        setCountries(data.data);
      } else {
        console.error("Invalid API response format:", data);
        setCountries([]);
      }
    } catch (error) {
      console.error("Error fetching countries:", error);
      setCountries([]);
    }
  };
  const fetchStates = async (countryId) => {
    if (!countryId) return;
    try {
      const response = await fetch(
        `${API_URL}Masters/GetStateList/${countryId}`
      );

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      console.log("Fetched States:", data);

      if (data && Array.isArray(data.data)) {
        setStates(data.data);
      } else {
        console.error("Invalid API response format:", data);
        setStates([]);
      }
    } catch (error) {
      console.error("Error fetching states:", error);
      setStates([]);
    }
  };
  const handleCountryChange = (event) => {
    const selectedId = event.target.value;
    setSelectedCountry(selectedId);
    fetchStates(selectedId);
  };
  const fetchMaritalStatuses = async () => {
    try {
      const response = await fetch(API_URL + "Masters/GetMaritalStatusList");
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      console.log("Fetched Data:", data);

      if (data && Array.isArray(data.data)) {
        setMaritalStatuses(data.data);
      } else {
        console.error("Invalid API response format:", data);
        setMaritalStatuses([]);
      }
    } catch (error) {
      console.error("Error fetching marital statuses:", error);
    }
  };
  const fetchEthnicities = async () => {
    try {
      const response = await fetch(API_URL + "Masters/GetEthinicityList");
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      console.log("Fetched Data:", data);

      if (data && Array.isArray(data.data)) {
        setEthnicities(data.data);
      } else {
        console.error("Invalid API response format:", data);
        setEthnicities([]);
      }
    } catch (error) {
      console.error("Error fetching ethnicities:", error);
    }
  };
  const fetchReligions = async () => {
    try {
      const response = await fetch(API_URL + "Masters/GetReligionList");
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      console.log("Fetched Data:", data);

      if (data && Array.isArray(data.data)) {
        setReligions(data.data);
      } else {
        console.error("Invalid API response format:", data);
        setReligions([]);
      }
    } catch (error) {
      console.error("Error fetching religions:", error);
    }
  };
  const fetchLanguages = async () => {
    try {
      const response = await fetch(API_URL + "Masters/GetLanguageList");
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      console.log("Fetched Language Data:", data);

      if (data && Array.isArray(data.data)) {
        setLanguages(data.data);
      } else {
        console.error("Invalid API response format:", data);
        setLanguages([]);
      }
    } catch (error) {
      console.error("Error fetching ethnicities:", error);
    }
  };
  const fetchExpertises = async () => {
    try {
      const response = await fetch(API_URL + "Masters/GetExpertiseList");
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      console.log("Fetched Expertise Data:", data);

      if (data && Array.isArray(data.data)) {
        setExpertises(data.data);
      } else {
        console.error("Invalid API response format:", data);
        setExpertises([]);
      }
    } catch (error) {
      console.error("Error fetching Expertise:", error);
    }
  };
  useEffect(() => {
    fetchMaritalStatuses();
    fetchEthnicities();
    fetchReligions();
    fetchCountries();
    fetchLanguages();
    fetchExpertises();
  }, []);
  return (
    <div>
      <CommonNavbar />
      <Card
        style={{
          width: "700px",
          boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
          border: "1px solid gray",
          borderRadius: "10px",
          marginLeft: "26%",
          padding: "20px",
          marginTop: "30px",
        }}
      >
        <Card.Body>
          <Card.Text>
            <center>
              {" "}
              <Card.Title>Counsellor Details</Card.Title>
            </center>
            <hr />
            <Form>
              <Form.Group className="mb-3" controlId="formFirstName">
                <Form.Label>First Name </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="First Name"
                  value={firstName}
                  readOnly
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formLastName">
                <Form.Label>Last Name </Form.Label>
                <Form.Control
                  type="lastName"
                  placeholder="Last Name"
                  className="form-control"
                  value={lastName}
                  readOnly
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formMobileNo">
                <Form.Label>
                  Mobile No<b style={{ color: "red" }}>*</b>
                </Form.Label>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  {/* <Form.Select
                    value={selectedCountryCode}
                    className="form-control"
                    onChange={(e) => setSelectedCountryCode(e.target.value)}
                    style={{ width: "100px" }}
                  >
                    {countries.map((country) => (
                      <option key={country.id} value={country.countryCode}>
                        {country.countryCode} ({country.countryName})
                      </option>
                    ))}
                  </Form.Select> */}

                  {/* Mobile No Input */}
                  <Form.Control
                    type="text"
                    placeholder="Mobile No"
                    value={mobileNo}
                    readOnly
                  />
                </div>
              </Form.Group>

              <Form.Group className="mb-3" controlId="formEmailId">
                <Form.Label>EmailId </Form.Label>
                <Form.Control
                  type="emailId"
                  placeholder="EmailId"
                  value={emailId}
                  readOnly
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formDateOfBirth">
                <Form.Label>Date of Birth </Form.Label>
                <b style={{ color: "red" }}>*</b>
                <Form.Control
                  type="date"
                  onChange={(e) => {
                    setDateOfBirth(e.target.value);
                    setDateOfBirthError("");
                  }}
                />
                {dateOfBirthError && (
                  <div style={{ color: "red" }}>{dateOfBirthError}</div>
                )}
              </Form.Group>
              <Form.Group className="mb-3" controlId="formGender">
                <Row>
                  <Col md={6}>
                    <Form.Label>Gender</Form.Label>
                    <b style={{ color: "red" }}>*</b>
                    <br />
                    <Form.Select
                      className="form-control"
                      onChange={(e) => {
                        setSelectedGender(e.target.value);
                        setGenderError("");
                      }}
                    >
                      <option value="">Select Gender</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </Form.Select>
                    {genderError && (
                      <div style={{ color: "red", marginTop: "5px" }}>
                        {genderError}
                      </div>
                    )}
                  </Col>

                  <Col md={6}>
                    <Form.Label>Marital Status</Form.Label>
                    <b style={{ color: "red" }}>*</b>
                    <Form.Select
                      className="form-control"
                      onChange={(e) => {
                        setSelectedMaritalStatus(e.target.value);
                        setMaritalStatusError("");
                      }}
                    >
                      <option value="">Select Marital Status</option>
                      {maritalStatuses.map((status) => (
                        <option
                          key={status.maritalStatusId}
                          value={status.maritalStatusId}
                        >
                          {status.maritalStatus}
                        </option>
                      ))}
                    </Form.Select>
                    {maritalStatusError && (
                      <div style={{ color: "red", marginTop: "5px" }}>
                        {maritalStatusError}
                      </div>
                    )}
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group className="mb-3" controlId="formCountry">
                <Row>
                  <Col md={6}>
                    <Form.Label>Country</Form.Label>
                    <b style={{ color: "red" }}>*</b>
                    <Form.Select
                      className="form-control"
                      onChange={handleCountryChange}
                    >
                      <option value="">Select Country</option>
                      {countries.map((country) => (
                        <option
                          key={country.countryId}
                          value={country.countryId}
                        >
                          {country.countryName}
                        </option>
                      ))}
                    </Form.Select>
                    {countryError && (
                      <div style={{ color: "red", marginTop: "5px" }}>
                        {countryError}
                      </div>
                    )}
                  </Col>

                  <Col md={6}>
                    <Form.Label>State</Form.Label>
                    <b style={{ color: "red" }}>*</b>
                    <br />
                    <Form.Select
                      className="form-control"
                      onChange={(e) => {
                        const val = e.target.value;
                        setSelectedState(val);
                        setStateError("");
                      }}
                    >
                      <option value="">Select State</option>
                      {states.map((state) => (
                        <option key={state.stateId} value={state.stateId}>
                          {state.stateName}
                        </option>
                      ))}
                    </Form.Select>
                    {stateError && (
                      <div style={{ color: "red", marginTop: "5px" }}>
                        {stateError}
                      </div>
                    )}
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group className="mb-3" controlId="formStreetAddress">
                <Form.Label>Street Address</Form.Label>
                <b style={{ color: "red" }}>*</b>
                <Form.Control
                  type="text"
                  placeholder="Enter Street Address"
                  onChange={(e) => {
                    setStreetAddress(e.target.value);
                    setStreetAddressError("");
                  }}
                />
                {streetAddressError && (
                  <div style={{ color: "red" }}>{streetAddressError}</div>
                )}
              </Form.Group>
              <Form.Group className="mb-3" controlId="formPincode">
                <Form.Label>Pincode</Form.Label>
                <b style={{ color: "red" }}>*</b>
                <Form.Control
                  type="text"
                  placeholder="Enter Pincode"
                  onChange={(e) => {
                    setPincode(e.target.value);
                    setPincodeError("");
                  }}
                />
                {pincodeError && (
                  <div style={{ color: "red" }}>{pincodeError}</div>
                )}
              </Form.Group>
              <Form.Group className="mb-3" controlId="formEthnicity">
                <Row>
                  <Col md={6}>
                    <Form.Label>Ethnicity</Form.Label>
                    <Form.Select
                      className="form-control"
                      onChange={(e) => {
                        const val = e.target.value;
                        setSelectedEthnicity(val);
                      }}
                    >
                      <option value="">Select Ethnicity</option>
                      {ethnicities.map((ethnicity) => (
                        <option
                          key={ethnicity.ethinicityId}
                          value={ethnicity.ethinicityId}
                        >
                          {ethnicity.ethinicity}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                  <Col md={6}>
                    <Form.Label>Religion</Form.Label>
                    <Form.Select
                      className="form-control"
                      onChange={(e) => {
                        const val = e.target.value;
                        setSelectedReligion(val);
                      }}
                    >
                      <option value="">Select Religion</option>
                      {religions.map((religion) => (
                        <option
                          key={religion.religionId}
                          value={religion.religionId}
                        >
                          {religion.religion}
                        </option>
                      ))}
                    </Form.Select>
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group className="mb-3" controlId="formLanguage">
                <Form.Label>Languages Known</Form.Label>
                <b style={{ color: "red" }}>*</b>
                <Select
                  isMulti
                  value={selectedLanguages.map((lang) => ({
                    value: lang.languageId,
                    label: lang.language,
                  }))}
                  onChange={(selected) => {
                    const updatedLanguages = selected.map((s) =>
                      languages.find((lang) => lang.languageId === s.value)
                    );
                    setSelectedLanguages(updatedLanguages);

                    const languagesString = updatedLanguages
                      .map((lang) => lang.language)
                      .join(", ");
                    setLanguagesKnown(languagesString);
                    setLanguagesError("");
                  }}
                  options={languages.map((lang) => ({
                    value: lang.languageId,
                    label: lang.language,
                  }))}
                  placeholder="Select Languages"
                  className="basic-multi-select"
                  classNamePrefix="select"
                />
                {languagesError && (
                  <div style={{ color: "red" }}>{languagesError}</div>
                )}
              </Form.Group>

              <Form.Group className="mb-3" controlId="formExpertise">
                <Form.Label>Expertise</Form.Label>
                <b style={{ color: "red" }}>*</b>
                <Select
                  isMulti
                  value={selectedExpertise.map((exp) => ({
                    value: exp.expertiseId,
                    label: exp.expertise,
                  }))}
                  onChange={(selected) => {
                    const updatedExpertise = selected.map((s) =>
                      expertises.find((exp) => exp.expertiseId === s.value)
                    );
                    setSelectedExpertise(updatedExpertise);

                    const expertiseString = updatedExpertise
                      .map((lang) => lang.expertise)
                      .join(", ");
                    setExpertise(expertiseString);

                    console.log(
                      "Selected expertise are:",
                      JSON.stringify(updatedExpertise)
                    );
                    console.log("expertise:", expertiseString);
                  }}
                  options={expertises.map((exp) => ({
                    value: exp.expertiseId,
                    label: exp.expertise,
                  }))}
                  placeholder="Select Expertise"
                  className="basic-multi-select"
                  classNamePrefix="select"
                />
                {expertiseError && (
                  <div style={{ color: "red" }}>{expertiseError}</div>
                )}
              </Form.Group>
              <Form.Group
                className="mb-3"
                controlId="formReligion"
              ></Form.Group>
              <br></br>
              <h5>Education Qualification</h5>
              <div
                style={{ border: "1px solid lightblue", borderRadius: "5px" }}
                className="p-2 mt-2"
              >
                <h6>Masters</h6>
                <Row>
                  <Col>
                    <Form.Group className="mb-3" controlId="formMastersDegree">
                      <Form.Label>Degree</Form.Label>
                      <b style={{ color: "red" }}>*</b>
                      <Form.Control
                        type="text"
                        placeholder="Enter Masters Degree"
                        onChange={(e) => setMasterDegree(e.target.value)}
                      />
                      {masterDegreeError && (
                        <div style={{ color: "red" }}>{masterDegreeError}</div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="formUniversity">
                      <Form.Label>University</Form.Label>
                      <b style={{ color: "red" }}>*</b>
                      <Form.Control
                        type="text"
                        placeholder="Enter University"
                        onChange={(e) => setMDUniversity(e.target.value)}
                      />
                      {mdUniversityError && (
                        <div style={{ color: "red" }}>{mdUniversityError}</div>
                      )}
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="formPassingYear">
                      <Form.Label>Passing Year</Form.Label>
                      <b style={{ color: "red" }}>*</b>
                      <Form.Control
                        type="text"
                        placeholder="Enter Passing Year"
                        onChange={(e) => setMDPassingYear(e.target.value)}
                      />
                      {mdPassingYearError && (
                        <div style={{ color: "red" }}>{mdPassingYearError}</div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
              </div>
              <br />
              <div
                style={{ border: "1px solid lightblue", borderRadius: "5px" }}
                className="p-2"
              >
                <h6>Graduation</h6>
                <Row>
                  <Col>
                    <Form.Group className="mb-3" controlId="formMastersDegree">
                      <Form.Label>Degree</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Graduation Degree"
                        onChange={(e) => setGraduationDegree(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="formUniversity">
                      <Form.Label>University</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter University"
                        onChange={(e) => setGDUniversity(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3" controlId="formPassingYear">
                      <Form.Label>Passing Year</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter Passing Year"
                        onChange={(e) => setGDPassingYear(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </div>
              <br />
              <div
                style={{ border: "1px solid lightblue", borderRadius: "5px" }}
                className="p-2"
              >
                <h6>Other Qualification</h6>
                <Row>
                  <Col>
                    <Form.Group>
                      <Form.Control
                        type="text"
                        placeholder="Enter Other Qualification"
                        onChange={(e) => setOtherQualification(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </div>
              <br />
              <Form.Group className="mb-3" controlId="formResumeUpload">
                <Form.Label>Upload Resume</Form.Label>
                <b style={{ color: "red" }}>*</b>
                <Form.Control
                  type="file"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      setSelectedResume(file);
                    }
                  }}
                />
                {resumeError && (
                  <div style={{ color: "red" }}>{resumeError}</div>
                )}
              </Form.Group>
              <br />
              <Form.Group className="mb-3" controlId="formYearsOfExperience">
                <Form.Label>Years of Experience</Form.Label>
                <b style={{ color: "red" }}>*</b>
                <Form.Control
                  type="number"
                  placeholder="Enter Years of Experience"
                  onChange={(e) => setYearsOfExperience(e.target.value)}
                />
                {yearsOfExperienceError && (
                  <div style={{ color: "red" }}>{yearsOfExperienceError}</div>
                )}
              </Form.Group>
              <br />
              <FormGroup>
                <Form.Label for="formimage"> Upload Profile Picture</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={(e) => {
                    const file = e.target.files[0];
                    if (file) {
                      setSelectedImage(file);
                    }
                  }}
                />
              </FormGroup>
              <br />
              <Form.Group className="mb-3" controlId="formBio">
                <Form.Label>Bio (in 100 words)</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Enter Bio in 100 words"
                  onChange={(e) => setBio(e.target.value)}
                />
              </Form.Group>
              <br />
              <Form.Group className="mb-3" controlId="formCheck">
                <Form.Label>Type of Counselling</Form.Label>
                <b style={{ color: "red" }}>*</b>
                <Row>
                  <Col>
                    <Form.Check
                      type="checkbox"
                      label="Individual Counselling"
                      name="IndividualCounselling"
                      onChange={(e) => {
                        setIndividualCounselling(e.target.checked);
                        setCounsellingError("");
                      }}
                    />
                  </Col>
                  <Col>
                    <Form.Check
                      type="checkbox"
                      label="Couple Counselling"
                      name="CoupleCounselling"
                      onChange={(e) => {
                        setCoupleCounselling(e.target.checked);
                        setCounsellingError("");
                      }}
                    />
                  </Col>
                  <Col>
                    <Form.Check
                      type="checkbox"
                      label="Family Counselling"
                      name="FamilyCounselling"
                      onChange={(e) => {
                        setFamilyCounselling(e.target.checked);
                        setCounsellingError("");
                      }}
                    />
                  </Col>
                </Row>

                {/* Show error if needed */}
                {counsellingError && (
                  <div style={{ color: "red", marginTop: "5px" }}>
                    {counsellingError}
                  </div>
                )}
              </Form.Group>

              <br />
              <center>
                <Button variant="primary" type="submit" onClick={handleSubmit}>
                  Submit
                </Button>
              </center>
            </Form>
          </Card.Text>
        </Card.Body>
      </Card>

      <br />

      <CommonFooter />
    </div>
  );
};
export default CounsellorRegistration;
